import getWindow from "./getWindow.js";
export default function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js
// module id = 111
// module chunks = 1